//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import * as videoProcessingApi from '@apis/video-processing/videoProcessingApi';
import { createNgApiAdapterService, GetNgApiAdapterType } from './createNgApiAdapter';

const videoProcessingApiService = createNgApiAdapterService(videoProcessingApi);
export type VideoProcessingApiService = GetNgApiAdapterType<typeof videoProcessingApiService>;

// Backwards compatibility: Use the old service name
angular.module('curalate').service('VideoProcessingService', videoProcessingApiService);
